import React, { FC } from 'react'

import EditIcon from '@mui/icons-material/Edit'

import {
	UserInitialPswdBox,
	UserInitialPswdLabel,
	UserInitialPswdCopyBtn,
} from './styled'

interface AppUserInitialPswdProps {
	readonly initialPassword: string
	readonly wrapperSx?: object
	readonly renderCustomLabel?: (pswd: string) => React.ReactNode
	readonly onClick?: React.MouseEventHandler<HTMLButtonElement>
	readonly renderCustomButton?: (
		onClick?: React.MouseEventHandler<HTMLButtonElement>
	) => React.ReactNode
}

const AppUserInitialPswd: FC<AppUserInitialPswdProps> = ({
	initialPassword,
	wrapperSx,
	renderCustomLabel,
	renderCustomButton,
	onClick,
}: AppUserInitialPswdProps) => {
	return (
		<UserInitialPswdBox sx={wrapperSx}>
			{!renderCustomLabel && (
				<UserInitialPswdLabel>{`Initial password: ${initialPassword}`}</UserInitialPswdLabel>
			)}

			{renderCustomLabel && renderCustomLabel(initialPassword)}

			{!renderCustomButton && (
				<UserInitialPswdCopyBtn size={'small'} onClick={onClick}>
					<EditIcon fontSize={'inherit'} />
				</UserInitialPswdCopyBtn>
			)}

			{renderCustomButton && renderCustomButton(onClick)}
		</UserInitialPswdBox>
	)
}

export default AppUserInitialPswd
